import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { FeedbackType, Message, MessageRequest } from '../../types/agent.dictionary'

export const AgentChatActions = createActionGroup({
  source: 'AgentChat',
  events: {
    getAgentResponse: props<{ payload: MessageRequest }>(),
    getAgentResponseStream: props<{ response: Omit<Message, 'author' | 'feedback'> }>(),
    getAgentResponseFailure: props<{ error: string }>(),
    getAgentResponseStreamCompleted: emptyProps(),
    userSendMessage: props<{ message: string; agentId: string; sessionId: string; image?: string }>(),
    cancelPendingRequest: emptyProps(),
    sendFeedback: props<{ feedback: FeedbackType; message: Message }>(),
    redoMessage: props<{ message: Message }>(),
    clearMessages: emptyProps(),
    addInitialMessage: props<{ initialMessage: string }>(),
  },
})
